<template>
    <v-row>
        <v-col class="col-lg-12 col-md-12 col-sm-12">
            <v-expansion-panels>
                <post-basic-information v-bind:postItem="postItem"></post-basic-information>
                <post-ingredients-component v-bind:postItem="postItem" v-if="postItem.type === 'Rezept'"></post-ingredients-component>
                <post-recipe-information-component v-bind:post-item="postItem" v-if="postItem.type === 'Rezept'"></post-recipe-information-component>
                <post-recipe-times-component v-bind:post-item="postItem" v-if="postItem.type === 'Rezept'"></post-recipe-times-component>
                <post-recipe-parts-component v-bind:post-item="postItem"  v-if="postItem.type === 'Rezept'" ></post-recipe-parts-component>
                <post-media-component v-bind:postItem="postItem" v-if="postItem.type !== ''"></post-media-component>
                <post-preview-component v-bind:post-item="postItem"></post-preview-component>
            </v-expansion-panels>
            <v-btn class="mt-3 saveButton" @click="saveBlogPost">Speichern</v-btn>
        </v-col>
        <v-overlay :value="overlay">
            <v-progress-circular
                    :size="80"
                    :width="10"
                    color="#E6007E"
                    indeterminate
            ></v-progress-circular>
        </v-overlay>
    </v-row>
</template>

<script>
  import PostBasicInformation from './components/PostBasicInformation'
  import PostIngredientsComponent from './components/PostIngredientsComponent'
  import PostRecipeInformationComponent from './components/PostRecipeInformationComponent'
  import PostRecipeTimesComponent from './components/PostRecipeTimesComponent'
  import PostRecipePartsComponent from './components/PostRecipePartsComponent'
  import PostMediaComponent from './components/PostMediaComponent'
  import PostPreviewComponent from './components/PostPreviewComponent'

  export default {
    name: 'Post',
    components: {
      PostBasicInformation,
      PostIngredientsComponent,
      PostRecipeInformationComponent,
      PostRecipeTimesComponent,
      PostRecipePartsComponent,
      PostMediaComponent,
      PostPreviewComponent
    },
    beforeMount () {
      let path = this.$router.currentRoute.path.substr(-4);
      if(path === 'edit'){
        this.postItem = this.$store.getters.postToEdit;
        this.postItem.opener_images_deleted = [];
        this.isEditing = true;
        if(this.postItem.opener_videos == null || this.postItem.opener_videos == ''){
          this.picYoutube = false;
        }else{
          this.picYoutube = true;
        }
        if(this.postItem.is_live !== undefined){
          this.postItem.is_active = parseInt(this.postItem.is_live);
        }
      }else{
        this.postItem.publishing_date_from_date = new Date().toISOString().substr(0, 10);
      }
    },
    data: () => {
      return {
        postItem: {
          "id": "",
          "blog_title":'',
          "meta_keywords": "",
          "meta_description": "",
          "meta_title": "",
          "new_category_id": "",
          "oldid": "",
          "title": "",
          "type": "",
          "publishing_date_from": "",
          "publishing_date_to": "",
          "tags": '',
          "is_active": 0,
          "is_featured": "",
          "days_marked_as_new": "",
          "main_category": "",
          "oldcategories": [],
          "count_diameter_pieces": 1,
          "recipe_type": "",
          "form_factor": "",
          "form_height": 0,
          "form_length": 0,
          "form_width": 0,
          "attribute_zubereitungszeit": "",
          "attribute_wartezeit": "",
          "attribute_backzeit": "",
          "attribute_kuehlzeit": "",
          "attribute_gefrierdauer": "",
          "attribute_kochzeit": "",
          "attribute_schwierigkeitsgrad": "",
          "opener_media_type": "images",
          "opener_images": [],
          "opener_images_deleted": [],
          "opener_videos": "",
          "recipe_container": [],
          "recipe_title": "",
          "opener_text": "",
          "content_container": [],
          "attribute_dauer": "",
          "attribute_grad": "",
          "attribute_heizart": "",
          'dreisc_seo_url':'',
          "recipeTitleAsSEO":false
        },
        isEditing: false,
        picYoutube: false,
        menu: false,
        statusMessage: '',
        errorMessage:'',
      }
    },
    computed:{
      overlay(){
        return this.$store.getters.postIsSaved
      }
    },
    methods: {
      saveBlogPost(){
        if(this.checkNeededValues()){
          this.$store.commit('togglePostIsSaved');
          this.$store.dispatch('savePostData',{isEditing:this.isEditing,content:this.postItem});
          this.$store.watch(
            (state) => state.postIsSaved,
            (value) => {
              if(!value){
                this.$store.dispatch('ask', {
                  title: 'Post ist gespeichert',
                  body: 'Der Post ist zur angegebenen Zeit im Blog sichtbar'
                }).then( () => {
                  this.$router.push('/posts')
                })
              }
            }
          )
        }else{
          this.$store.dispatch('ask', {
            title: 'Was vergessen?',
            body: this.errorMessage,
          }).then(() => {
            this.overlay = false;
          })
        }
      },
      checkNeededValues(){
        if(!this.basisPreFlight()){
          return false;
        }
        if(this.postItem.type === 'Rezept'){
          if(!this.recipePreflight()){
            return false;
          }
          if(!this.contentPreFlight()){
            return false;
          }
        }
        if(!this.mediaPreFlight()){
          return false;
        }
        return true;
      },
      basisPreFlight(){
        if(this.postItem.blog_title === ''){
          this.errorMessage = 'Basis Informationen -> Blog Titel';
          return false;
        }
        if(this.postItem.type === ''){
          this.errorMessage = 'Basis Informationen -> Blog Typ';
          return false;
        }else{
          if(this.postItem['new_category_id'] === ''){
            this.errorMessage = 'Basis Informationen -> Blog Kategorie';
            return false;
          }else{
            if(this.postItem.opener_text === '' && this.postItem.type === 'Rezept'){
              this.errorMessage = 'Basis Informationen -> Beschreibung';
              return false;
            }
            if(typeof(this.postItem.publishing_date_from_time) === "undefined"){
              this.errorMessage = 'Basis Informationen -> Uhrzeit';
              return false;
            }
          }
        }
        return true;
      },
      recipePreflight(){
        /*if(this.postItem.type === 'Rezept'){
          if(this.postItem.recipe_container.length < 1 && this.postItem.content_container.length < 1){
            this.errorMessage = 'Zutaten sind nicht vorhanden. \nDas Rezept hat keine Rezeptabschnitte.';
            return false;
          }
          if(this.postItem.recipe_container.length < 1){
            this.errorMessage = 'Zutaten sind nicht vorhanden.';
            return false;
          }
          if(this.postItem.recipe_container.length < 2){
            this.errorMessage = 'Bitte eine ganze Zutat anlegen.';
            return false;
          }else if(this.postItem.recipe_container.length < 3 && this.postItem.recipe_container[1].recipe_amount == 0){
            this.errorMessage = 'Bitte die Zutat korrekt ausfüllen.';
            return false;
          }

          if(this.postItem.recipe_type === ''){
            this.errorMessage = 'Rezept Informationen -> Stück/Portion/Durchmesser';
          }

          if(this.postItem.form_factor === ''){
            this.errorMessage = 'Rezept Informationen -> Backform auswählen';
          }
        }*/
        return true;
      },
      contentPreFlight(){

        if(this.postItem.type === 'Rezept' && this.postItem.content_container.length < 1){
          this.errorMessage = 'Das Rezept hat keine Rezeptabschnitte.';
          return false;
        }

        let noContent = true;
        this.postItem.content_container.forEach(item => {
          if(item.content_element_text !== '' && this.postItem.type === 'Rezept'){
            noContent = false;
          }
        });

        if(noContent && this.postItem.type === 'Rezept'){
            this.errorMessage = 'Rezeptabschnitt -> Kein Inhalt vorhanden';
            return false;
        }
        return true;
      },
      mediaPreFlight(){
        if(this.postItem.type === 'OnTour' || this.postItem.type === 'Technikwelt'){
          if(this.postItem.opener_videos == ''){
            this.errorMessage = 'Medien -> keine YouTube ID';
            return false;
          }
        }
        if(this.postItem.opener_images.length < 1){
          this.errorMessage = 'Medien -> keine Bilder';
          return false;
        }else if(this.postItem.opener_images.length > 0){

          if(this.postItem.type === 'Rezept'){
            let previewFound = false;
            this.postItem.opener_images.forEach(item => {
              if(item.preview){
                previewFound = true;
              }
            })

            if(!previewFound){
              this.errorMessage = 'Medien -> keine Vorschau gesetzt';
              return false;
            }
          }
        }
        return true;
      }
    },
    watch: {
      selectedKinfOf(val){
        if(val === 'Durchmesser'){
          this.minPieces = 0;
          this.maxPieces = 60;
        }else if(val === 'Stück'){
          this.minPieces = 0;
          this.maxPieces = 26;
        }else if(val === 'Person'){
          this.minPieces = 0;
          this.maxPieces = 100;
        }
      }
    }
  }
</script>

<style scoped>
    .container.fill-height{
        align-items: initial;
    }

    .saveButton:hover{
        background-color: #E6007E !important;
        opacity: .8;
    }


</style>
